<section class="story-export-card" #storyExportCard>
  <header class="story-export-card__logo-frame">
    <img class="story-export-card__logo" [src]="brandLogoPath" alt="{{ 'CAMPAIGN.BrandAlt' | translate }}" />
  </header>

  <section class="story-export-card__hero">
    <img [src]="storyHeroImageUrl" alt="{{ 'CAMPAIGN.Story.HeroAlt' | translate }}" (error)="onStoryImageError($event)" />
    <div class="story-export-card__hero-overlay"></div>
  </section>

  <section class="story-export-card__copy">
    <h1>
      {{ storyHeadingLead }} <span>{{ storyHeadingAccent }}</span>
    </h1>
    <p>{{ primaryStoryText }}</p>
  </section>

  <p class="story-export-card__context">{{ campaignContextText }}</p>

  <section class="story-export-card__progress-card">
    <div class="story-export-card__donut-wrap">
      <svg class="story-export-card__donut" viewBox="0 0 220 220" aria-hidden="true">
        <defs>
          <linearGradient [attr.id]="progressGradientId" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#F8A33A"></stop>
            <stop offset="60%" stop-color="#F68A31"></stop>
            <stop offset="100%" stop-color="#F2742C"></stop>
          </linearGradient>
        </defs>

        <circle
          class="story-export-card__donut-track-outline"
          cx="110"
          cy="110"
          [attr.r]="progressRadius"
        ></circle>
        <circle
          class="story-export-card__donut-track"
          cx="110"
          cy="110"
          [attr.r]="progressRadius"
        ></circle>
        <circle
          class="story-export-card__donut-fill"
          cx="110"
          cy="110"
          [attr.r]="progressRadius"
          [attr.stroke-dasharray]="progressCircumference"
          [attr.stroke-dashoffset]="progressDashOffset"
          [attr.stroke]="'url(#' + progressGradientId + ')'"
        ></circle>
      </svg>

      <div class="story-export-card__donut-center">
        <span class="story-export-card__percent">{{ storyProgressText }}%</span>
        <span class="story-export-card__percent-label">{{ storyPercentLabel }}</span>
      </div>
    </div>

    <div class="story-export-card__stats">
      <div class="story-export-card__stat">
        <span class="story-export-card__stat-label">{{ storyTargetLabel }}</span>
        <strong class="story-export-card__stat-value">{{ formatUsd(targetAmount) }}</strong>
      </div>
      <div class="story-export-card__stat">
        <span class="story-export-card__stat-label">{{ storyRaisedLabel }}</span>
        <strong class="story-export-card__stat-value story-export-card__stat-value--accent">{{ formatUsd(currentAmount) }}</strong>
      </div>
      <div class="story-export-card__stat">
        <span class="story-export-card__stat-label">{{ storyRemainingLabel }}</span>
        <strong class="story-export-card__stat-value">{{ formatUsd(remainingAmount) }}</strong>
      </div>
    </div>
  </section>

  <div class="story-export-card__proof">
    <svg viewBox="0 0 24 20" aria-hidden="true">
      <path d="M12 18.5C11.6 18.5 11.2 18.35 10.9 18.05L3.3 10.7C1.35 8.82 1.35 5.78 3.3 3.9C5.25 2.02 8.4 2.02 10.35 3.9L12 5.49L13.65 3.9C15.6 2.02 18.75 2.02 20.7 3.9C22.65 5.78 22.65 8.82 20.7 10.7L13.1 18.05C12.8 18.35 12.4 18.5 12 18.5Z"></path>
    </svg>
    <span>{{ donorsLabel }}</span>
  </div>

  <footer class="story-export-card__footer">
    <div class="story-export-card__divider"></div>
    <p>{{ storyDonateAtLabel }}</p>
    <strong>crezcofoundation.org</strong>
  </footer>
</section>
